module.exports = {"supported-by":"技術支援","thanks":"謝謝","invalid-tenantid":{"headline":"無效的TenantId","contact-admin":"請聯絡您的管理員以獲得正確的tenantId"},"checkout":{"secure-payment":"安全付款環境","name":"姓名","name-placeholder":"例如：陳大文","email":"電郵地址","email-placeholder":"例如：youremail@gmail.com","policy":"保單號碼","policy-placeholder":"例如：參考號碼：#123456","payment-amount":"付款金額（金額需包括保費徵費）","payment-amount-placeholder":"例如：100.00","credit-card":"信用卡（請填寫卡號、有效日期和安全碼)","credit-card-error":"您的付款程序出錯了","total":"總計","total-includes":"此金額包括5%手續費","loading":"請稍等...","proceed":"確認付款"}}


//////////////////
// WEBPACK FOOTER
// ./src/locale/zh-HK.json
// module id = hNBT
// module chunks = 1